import React, { Component } from 'react';
import { Table } from "reactstrap";
import './Products.css';
import { Edit2, Trash, Users, Play, Unlock, Flag, RefreshCw, ShoppingBag } from "react-feather";
import { Col, OverlayTrigger, Row, Tooltip, Badge } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Moment from "moment";
import AddChallengeModal from "./modals/AddChallengeModal";
import DeleteChallengeModal from "./modals/DeleteChallengeModal";
import ChallengeParticipants from "./ChallengeParticipants";
import ChallengeShopLottery from "./ChallengeShopLottery";
import { apiFetch, API } from "../services/api";

const STATUS_LABELS = {
    draft: ["Brouillon", "secondary"],
    open: ["Inscriptions ouvertes", "info"],
    running: ["En cours", "success"],
    closed: ["Clôturé", "dark"],
};

const ACTION_LABELS = {
    open: "Ouvrir les inscriptions (page publique visible, points pas encore comptés)",
    start: "Démarrer (les points sont comptés à partir de maintenant)",
    close: "Clôturer (classement figé, récap envoyé)",
    recalculate: "Recalculer maintenant (sans attendre le prochain passage du robot)",
};

function getChallenges() {
    return apiFetch(API.back + '/challenges', { method: 'GET' }).then(res => res.json());
}

function getRewards() {
    return apiFetch(API.back + '/rewards', { method: 'GET' }).then(res => res.json());
}

function postAction(id, action) {
    return apiFetch(API.back + '/challenge-action', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, action }),
    }).then(async res => {
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body.message || "Erreur");
        return body;
    });
}

export class ChallengesList extends Component {
    state = {
        challenges: null,
        rewards: [],
        errors: null,
        notice: null,
        isOpen: false,
        isDelete: false,
        isParticipants: false,
        isShop: false,
        selected: null,
        busy: null,
    };

    async componentDidMount() {
        await this.refresh();
        getRewards().then(data => this.setState({ rewards: Array.isArray(data) ? data : [] })).catch(() => {});
    }

    refresh = () => getChallenges()
        .then(data => this.setState({ challenges: Array.isArray(data) ? data : [], errors: null }))
        .catch(() => this.setState({ errors: "error while getting challenges" }));

    closeModal = () => this.setState({ isOpen: false, isDelete: false, isParticipants: false, isShop: false, selected: null });

    action = (challenge, action) => {
        if (action === "close" && !window.confirm(`Clôturer « ${challenge.name} » ? Le classement sera figé et le récapitulatif envoyé.`)) return;
        if (action === "start" && !window.confirm(`Démarrer « ${challenge.name} » maintenant ? La date de début sera avancée à aujourd'hui si besoin.`)) return;
        this.setState({ busy: challenge.id + action, notice: null });
        postAction(challenge.id, action)
            .then(async () => {
                await this.refresh();
                this.setState({ notice: action === "recalculate" ? "Recalcul demandé : résultats dans ~1 min." : "Action appliquée." });
            })
            .catch(err => this.setState({ errors: err.message }))
            .finally(() => this.setState({ busy: null }));
    };

    render() {
        const { challenges, errors, notice, busy, rewards } = this.state;
        return (
            <div className="products-list">
                <Row>
                    <Col sm={12} className="products-buttons">
                        <Button className="add-product-button" variant="secondary"
                                onClick={() => this.setState({ isOpen: true, selected: null })}>
                            Créer un challenge
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} className="products-buttons">
                        {challenges && errors == null ? <span>{challenges.length} challenge{challenges.length === 1 ? "" : "s"}</span> : null}
                        {notice ? <span style={{ marginLeft: 12, color: "#27ae60" }}>{notice}</span> : null}
                    </Col>
                </Row>

                {errors != null ? <p style={{ color: "#c0392b" }}>{errors}</p> : null}

                {(!challenges && errors == null) ? <p>Chargement ...</p> :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Slug</th>
                            <th>Marché</th>
                            <th>Statut</th>
                            <th>Dates</th>
                            <th>Paliers</th>
                            <th>Modifié le</th>
                            <th colSpan={7}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {challenges && challenges.map(c => {
                            const [label, variant] = STATUS_LABELS[c.status] || [c.status, "light"];
                            const cell = (Icon, tooltip, onClick, disabled) => (
                                <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
                                    <td className="table-action" style={{ cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.3 : 1 }}>
                                        <Icon className="align-middle" size={18} onClick={disabled ? undefined : onClick} />
                                    </td>
                                </OverlayTrigger>
                            );
                            return (
                                <tr key={c.id}>
                                    <td>{c.name}</td>
                                    <td><a href={`https://app.therunningcollective.${c.language === "es" ? "es" : "fr"}/challenge/${c.slug}`} target="_blank" rel="noreferrer">/challenge/{c.slug}</a></td>
                                    <td>{(c.language || "all").toUpperCase()}</td>
                                    <td><Badge variant={variant}>{label}</Badge></td>
                                    <td>{Moment(c.beginDate).utc().format("DD/MM/YYYY")} → {Moment(c.endDate).utc().format("DD/MM/YYYY")}</td>
                                    <td>{(c.tiers || []).length}</td>
                                    <td>{c.modifiedDate ? Moment(c.modifiedDate).format("DD/MM/YYYY HH:mm") : "—"}</td>
                                    {cell(Edit2, "Modifier", () => this.setState({ isOpen: true, selected: c }))}
                                    {cell(Users, "Participants, exclusion, exports", () => this.setState({ isParticipants: true, selected: c }))}
                                    {cell(ShoppingBag, "Boutique & loterie : achats, tirages, paniers 1 minute", () => this.setState({ isShop: true, selected: c }), c.mechanics !== "shop")}
                                    {cell(Unlock, ACTION_LABELS.open, () => this.action(c, "open"), c.status !== "draft" || !!busy)}
                                    {cell(Play, ACTION_LABELS.start, () => this.action(c, "start"), !(c.status === "draft" || c.status === "open") || !!busy)}
                                    {cell(Flag, ACTION_LABELS.close, () => this.action(c, "close"), c.status !== "running" || !!busy)}
                                    {cell(RefreshCw, ACTION_LABELS.recalculate, () => this.action(c, "recalculate"), c.status !== "running" || !!busy)}
                                    {cell(Trash, "Supprimer", () => this.setState({ isDelete: true, selected: c }), c.status === "running")}
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                }

                <p className="text-muted" style={{ fontSize: 12 }}>
                    Cycle : Brouillon → Inscriptions ouvertes (page visible, inscriptions et partages comptés, pas de points) → En cours (robot toutes
                    les 15 min : visites, comptes, partages, paliers, rappel 18 h) → Clôturé (automatique à la date de fin, ou manuel).
                    Les lots : export « lots à envoyer » depuis les participants.
                </p>

                {this.state.isOpen ?
                    <AddChallengeModal key={(this.state.selected && this.state.selected.id) || "new"} closeModal={this.closeModal}
                                       isOpen={this.state.isOpen} selectedChallenge={this.state.selected} rewards={rewards} refresh={this.refresh} /> : null}
                {this.state.isDelete ?
                    <DeleteChallengeModal closeModal={this.closeModal} isOpen={this.state.isDelete} selectedItem={this.state.selected} refresh={this.refresh} /> : null}
                {this.state.isShop ?
                    <ChallengeShopLottery closeModal={this.closeModal} isOpen={this.state.isShop} challenge={this.state.selected} /> : null}
                {this.state.isParticipants ?
                    <ChallengeParticipants closeModal={this.closeModal} isOpen={this.state.isParticipants} challenge={this.state.selected} /> : null}
            </div>
        );
    }
}
